import { defineMessages } from 'react-intl'

import { GTCampaignArea, GTCampaignType } from 'gql/types.generated'
import { TCampaignMessages } from './types'

export const campaignAreaMessages = defineMessages({
  [GTCampaignArea.Marketing]: {
    id: 'campaignType.marketing',
    defaultMessage: 'Marketing'
  },
  [GTCampaignArea.CustomerSupport]: {
    id: 'campaignType.customerSupport',
    defaultMessage: 'Customer Support'
  },
  [GTCampaignArea.Snacks]: {
    id: 'campaignType.snacks',
    defaultMessage: 'Snacks'
  },
  [GTCampaignArea.Sales]: {
    id: 'campaignType.sales',
    defaultMessage: 'Sales'
  },
  [GTCampaignArea.Partners]: {
    id: 'campaignType.partners',
    defaultMessage: 'Partners'
  },
  [GTCampaignArea.Travel]: {
    id: 'campaignType.travel',
    defaultMessage: 'Travel'
  },
  [GTCampaignArea.Mobile]: {
    id: 'campaignType.mobile',
    defaultMessage: 'Mobile'
  }
})

export const campaignTypeMessages = defineMessages({
  [GTCampaignType.Incidence]: {
    id: 'campaignType.incidence',
    defaultMessage: 'Incidence'
  },
  [GTCampaignType.GeneralCoupon]: {
    id: 'campaignType.generalCoupon',
    defaultMessage: 'General Coupon'
  },
  [GTCampaignType.UniqueCouponForDatabase]: {
    id: 'campaignType.uniqueCouponForDatabase',
    defaultMessage: 'Unique Coupon for Database'
  }
}) as TCampaignMessages
